import classNames from 'classnames'

interface LoadingIconProps {
  className?: string
}

export function LoadingIcon({ className }: LoadingIconProps) {
  return (
    <div
      className={classNames(
        'w-4 h-4 aspect-square animate-spin-fast',
        className
      )}
    >
      <svg width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
        <path
          d='M-0.000412941 11.6077C-0.000412941 2.71598 7.97703 5.0274e-05 11.8537 0C12.5137 -8.55829e-06 13.5137 0.253906 13.5137 1.2538C13.5137 1.75391 13.0137 2.2538 11.8537 2.50982C9.00907 3.13768 2.46453 3.91707 2.46453 11.6077C2.46453 19.2983 9.08252 23.0734 12.3915 23.9996C8.26087 23.5738 -0.000412941 20.4994 -0.000412941 11.6077Z'
          fill='currentColor'
        />
      </svg>
    </div>
  )
}
